module.exports = __webpack_public_path__ + "media/img/frontend_application/promo-badge-ceefe8aa5e7d0a26e9e9c558de369b10.png";